<template>
  <c-main>
    <c-panel>
      <header class="toolbar u-pl-0 u-pr-0">
        <div class="toolbar__group l-level">
          <div class="l-level__left">
            <div class="cell">
              <div class="cell__media">
                <i class="icon-stats-bars3"></i>
              </div>
              <div class="cell__content">
                <h1 class="toolbar__title">Competitions List</h1>
              </div>
            </div>
          </div>
          <div class="l-level__right">
            <c-button
              @click="$router.push({name: 'CompetitionCreate'})"
              type="success"
              smart
              icon-start="icon-plus-circle"
            >New Competition</c-button>
          </div>
        </div>
      </header>

      <data-table
        @delete="doAlertDelete"
        @archive="doAlertArchive"
        @duplicate="doDuplicate"
        v-bind:settings="acListSettings"
        ref="datatable"
      ></data-table>
    </c-panel>
  </c-main>
</template>

<script>
import DataTables from "@/components/Tables";
import moment from 'moment'


export default {
  name: "CompetitionsList",
  components: {
    "data-table": DataTables,
  },
  data() {
    return {
      acListSettings: {
        dataUrl: this.$cfg.API_URL + "/competitions/get-list/",
        order_by: { _id: -1 },
        search_by: 'name',
        cols: [
          {
            title: "Name",
            name: "name",
            sortable: true,
            type: "render",
            render: function (row, col) {
                let cls = row.status == 'enabled' ? 'badge--success' : 'badge--warning';

                return [
                    '<a href="/secure/competitions/edit/' + row._id + '">' + row.name + '</a>',
                    '<span class="u-uppercase badge ' + cls + '">' + row.status + '</span>'
                ].join('<br/>')
            }
          },
          {
            title: "Group",
            name: "group",
            sortable: false,
            type: "render",
            render: function (row, col) {
              return row.groups.map( _ => '<span class="table-label">' + _.key + '</span>' ).join('<br/>')

              let groups = '';
              if(row.groups) {
                for(let g of row.groups)
                  groups += '<span class="table-label">' + g.key + '</span>';
                
              }
              return groups;
            },
          },
              
          {
            title: "Entrants",
            name: "entrants",
            sortable: false,
            type: "render",
            render: function (row, col) {
              let additional_fields = ''
              let segments = row.segments.map( _ => '<span class="u-font-bold">#' + _.id + ':</span> ' + _.name ).join('<br/>')
              let days = ''

              let wkDays = {
                  1: 'MON',
                  2: 'TUE',
                  3: 'WED',
                  4: 'THU',
                  5: 'FRI',
                  6: 'SAT',
                  7: 'SUN'
              }
              
              let result = []

              if ( row.active_wk_days && row.active_wk_days.length != 7 ) {
                  days = row.active_wk_days.map( _ => '<span class="badge badge--primary">' + wkDays[ _ ] + '</span>' ).join('')
              }

              if ( !!row.additional_fields ) {
                  additional_fields = Object.keys( row.additional_fields )
                                        .filter( k => !!row.additional_fields[k] && row.additional_fields[k].length )
                                        .map( k => ['<span class="u-font-bold">' + k + '</span>', row.additional_fields[k].join(', ') ].join(': ') )
                                        .join('<br />')
              }

              if ( !!days ) {
                  result.push( days )
              }

              if ( !!additional_fields ) {
                  additional_fields = 'Additional fields:<br/>' + additional_fields
                  result.push( additional_fields )
              }

              if ( !!segments ) {
                  segments = 'Segments:<br/>' + segments
                  result.push( segments )
              }

              return result.join('<br/>')
            },
          },

          {
            title: "Achievements",
            name: "achievements",
            sortable: false,
            type: 'render',
            render: function(row, col){
                return row.achievements.map( _ => '<a href="/secure/achievements/edit/' + _.value + '">' + _.label + '</a>' ).join('<br/>')
            }
          },
          {
            title: "Dates",
            name: "start_date",
            sortable: true,
            type: 'render',
            width: 110,
            render: function(row, col){
                return [
                    !!row.start_date ? moment( row.start_date ).format('YYYY-MM-DD') : 'Not Set',
                    !!row.end_date ? moment( row.end_date ).format('YYYY-MM-DD') : 'Not Set',
                ].join('<br/>')
            }
          },
          {
            title: "Action",
            type: "render",
            render: function (row, col) {
              return '<button data-action="duplicate" class="btn btn--warning btn--sm btn--smart" style="margin-right:5px;margin-bottom:2px;">Clone</button><br/>' + (row.started && row.status != "archived"
                ? '<button data-action="archive" class="btn btn--info btn--sm btn--smart">Archive</button>'
                : !row.started && row.status != "archived"
                ? '<button data-action="delete" class="btn btn--danger btn--sm btn--smart">Delete</button>'                
                : "");
            },
          },
        ],
        filterButtons: [
          {
            title: "All",
            code: "all",
            filter_rule: '{"status": {"$in": ["draft", "enabled", "expired"]}}',
          },
          {
            title: "Draft",
            code: "draft",
            filter_rule: '{"status": "draft"}',
          },
          {
            title: "Enabled",
            code: "enabled",
            filter_rule: '{"status": "enabled"}',
          },
          {
            title: "Expired",
            code: "expired",
            filter_rule: '{"status": "expired"}',
          },
          {
            title: "Archived",
            code: "archived",
            filter_rule: '{"status": "archived"}',
          }
        ],
      },
    };
  },
  methods: {
    doDuplicate: function (acId) {
      const _this = this;
      if(this.confirmActive)
        return;
      this.confirmActive = true;

      this.$alert({
        type: "error",
        title: "Info",
        content:
          "Are you sure you want to clone this competition.",
        showCancel: true,
        onConfirm: () => {
          const vm = this.$toast.loading("Processing...");
          _this.confirmActive = false;

          _this.$axios
            .post(_this.$cfg.API_URL + "/competitions/duplicate/", { _id: acId })
            .then((data) => {
              this.$notify({
                type: "success",
                title: "Competition is sucessfully cloned into a new one",
                closeable: true,
                duration: 5000,
              });
              vm.hide();

              _this.$refs.datatable.refresh();
            })
            .catch((err) => {});
        },
        onCancel: () => {_this.confirmActive = false;},
      });
    },
    doAlertDelete: function (acId) {
      const _this = this;
      if(this.confirmActive)
        return;
      this.confirmActive = true;

      this.$alert({
        type: "error",
        title: "Info",
        content:
          "Are you sure you want to delete this competition? This action cannot be undone.",
        showCancel: true,
        onConfirm: () => {
          const vm = this.$toast.loading("Processing...");
          _this.confirmActive = false;

          _this.$axios
            .post(_this.$cfg.API_URL + "/competitions/delete/", { _id: acId })
            .then((data) => {
              this.$notify({
                type: "success",
                title: "Competition is sucessfully deleted",
                closeable: true,
                duration: 5000,
              });
              vm.hide();

              _this.$refs.datatable.refresh();
            })
            .catch((err) => {});
        },
        onCancel: () => {_this.confirmActive = false;},
      });
    },
    doAlertArchive: function (acId) {
      const _this = this;
      if(this.confirmActive)
        return;
      this.confirmActive = true;

      this.$alert({
        type: "error",
        title: "Info",
        content: "Are you sure you want to archive this competition?",
        showCancel: true,
        onConfirm: () => {
          const vm = this.$toast.loading("Processing...");
          _this.confirmActive = false;

          _this.$axios
            .post(_this.$cfg.API_URL + "/competitions/status", {
              _id: acId,
              status: "archived",
            })
            .then((data) => {
              this.$notify({
                type: "success",
                title: "Competition is sucessfully archived",
                closeable: true,
                duration: 5000,
              });
              vm.hide();

              _this.$refs.datatable.refresh();
            })
            .catch((err) => {});
        },
        onCancel: () => {_this.confirmActive = false;},
      });
    }    
  },
};
</script>